/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React from "react";
import { Button } from "@forge/common";
import "./Buttons.scss";

/**
 * Reusable buttons
 */

interface IProps {
  btnText: string;
  style?: any;
  onClick: () => void;
  ariaLabel?: string;
}

export const PrimaryBtn = (props: IProps) => {
  return (
    <Button
      variant="primary"
      className="primary-btn"
      style={props.style}
      onClick={() => props.onClick()}
      aria-label={props.ariaLabel}
    >
      {props.btnText}
    </Button>
  );
};

export const TextBtn = (props: IProps) => {
  return (
    <Button
      variant="primary"
      className="text-btn"
      onClick={() => props.onClick()}
      aria-label={props.ariaLabel}
    >
      {props.btnText}
    </Button>
  );
};
export const SecondaryBtn = (props: IProps) => {
  return (
    <Button
      variant="secondary"
      className="text-btn"
      onClick={() => props.onClick()}
      aria-label={props.ariaLabel}
    >
      {props.btnText}
    </Button>
  );
};
